import PropTypes from 'prop-types'
import React from 'react'

const TextFieldSkeleton = ({ loading, children, width }) => {
  if (loading) {
    return (
      <div className={`skeleton skeleton--text-field skeleton--${width}`} />
    )
  }

  return children
}

TextFieldSkeleton.defaultProps = {
  width: 'full'
}

TextFieldSkeleton.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool.isRequired,
  width: PropTypes.string
}

export default TextFieldSkeleton
